import { Box, Typography } from '@mui/material';
import { UserEntity } from 'app/interfaces/entity';
import classNames from 'classnames';
import { TournamentUserRoleNames } from 'modules/tournaments/enums';
import React, { FC } from 'react';
import { UnknownUserAvatar } from 'shared/components/UnknownUserAvatar';
import { UserAvatar } from 'shared/components/UserAvatar';
import { useStyles } from './AdminCard.styles';

interface AdminCardProps {
  user?: Partial<UserEntity> | null;
  isOwner?: boolean;
}

export const AdminCard: FC<AdminCardProps> = ({ user = null, isOwner = false }) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.root}>
      <Box className={classes.userInfo}>
        {user ? <UserAvatar user={user} /> : <UnknownUserAvatar />}
        <Box pl={1}>
          <Typography className={classNames(classes.text, classes.name)}>
            {user?.userName}
          </Typography>
          <Typography className={classNames(classes.text, classes.roleName)}>
            {isOwner ? TournamentUserRoleNames.TournamentCreator : TournamentUserRoleNames.Admin}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};
